import o from"styled-components";import{theme as i}from"../../../../../theme.js";const e=o.label`
  border: 1px dashed ${i.colors.gray[400]};
  background-color: ${i.colors.gray[50]};
  border-radius: ${i.radius}px;
  min-height: 160px;
  max-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  > input {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
  }
`,t=o.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${i.spacing*2}px;
  cursor: pointer;
  width: 100%;
  height: 100%;
  > span {
    display: block;
    font-size: 14px;
    font-weight: 700;
    color: ${i.colors.primary[500]};
    &.drag {
      font-size: 12px;
      font-weight: 400;
      color: ${i.colors.gray[500]};
    }
  }
  > svg {
    width: 20px;
    height: 20px;
    > g, path {
      fill: ${i.colors.primary[500]};
    }
  }
  @media screen and (max-width: ${i.breakpoints.md}) {
    > span {
      &.drag {
        display: none;
      }
    }
  }
`,r=o.div`
  position: absolute;
  z-index: 10;
  top: 16px;
  left: 16px;
  width: calc(100% - 32px);
  display: flex;
  align-items: center;
  justify-content: space-between;
`,n=o.button`
  border: none;
  font-size: 14px;
  font-weight: 700;
  display: grid;
  align-items: center;
  height: 40px;
  background-color: ${i.colors.gray[50]};
  cursor: pointer;
  transition: all .2s ease-in-out;
  color: ${i.colors.gray[900]};
  &.iconWithText {
    grid-template-columns: 20px max-content;
    grid-column-gap: ${i.spacing*2}px;
    padding: 0 ${i.spacing*3}px;
    border-radius: ${i.radius}px;
  }
  &.text {
    grid-template-columns: max-content;
    padding: 0 ${i.spacing*3}px;
    border-radius: ${i.radius}px;
  }
  > svg {
    width: 20px;
    height: 20px;
    > g, path {
      fill: ${i.colors.gray[900]};
    }
  }
  &:hover {
    background-color: ${i.colors.gray[200]};
  }
`,a=o.div`
  width: 100%;
  height: 200px;
  display: flex;
  overflow: hidden;
  > div {
    flex-grow: 1;
    position: relative;
    img {
      width: 100%;
      height: 200px;
      object-fit: cover;
      border-radius: ${i.radius}px;
    }
    .more {
      background-color: rgba(0, 0, 0, 0.5);
      font-size: 24px;
      font-weight: 700;
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 1;
      color: ${i.colors.shades[0]};
      top: 0;
      left: 0;
      border-radius: ${i.radius}px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;export{n as Button,r as ButtonsContainer,e as Container,t as PlaceholderContainer,a as PreviewContainer};
